import store from '../store';

export default class TokenUtils {
  /**
   * Get the authorization token from the authentication state
   */
  static getAuthToken() {
    const { authentication = {}, } = store.getState().auth;
    return authentication.token;
  }

  /**
   * Get the tenant user ID from the authentication state
   */
  static getTenantUserId() {
    const { authentication = {}, } = store.getState().auth;
    return authentication.tenantUserId;
  }

  /**
   * Get standard headers for API requests
   */
  static getRequestHeaders() {
    const headers = {};
    const token = TokenUtils.getAuthToken();
    const tenantUserId = TokenUtils.getTenantUserId();

    if (token) {
      // Athos backend expects token without Bearer prefix
      headers.Authorization = token;
    }
    if (tenantUserId) {
      headers['tenant.user.id'] = tenantUserId;
    }

    return headers;
  }
}
